import React from 'react';

const Logo = ({ size = 'md', mobile = false }) => {
  const sizes = {
    sm: 'h-10 w-auto',
    md: 'h-16 w-auto',
    lg: 'h-24 w-auto',
  };

  // Mobile için yazısız, desktop için yazılı logo
  const logoSrc = mobile ? '/logo-mobile.png' : '/logo.png';

  return (
    <div className={`${sizes[size]} relative flex items-center`} data-testid="company-logo">
      <img 
        src={logoSrc}
        alt="Ener Yazılım Logo" 
        className={`${sizes[size]} object-contain`}
      />
    </div>
  );
};

export default Logo;